import { IconName } from '@fortawesome/fontawesome-svg-core';
import type { Router as RemixRouter } from '@remix-run/router';
import qs from 'qs';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { RoutesName } from './routes-name';
import Endpoints from '../datasource/endpoints';

export type RouteDefinition = { title: string; icon?: IconName | Array<IconName>; path: string; component: any; index?: boolean };
export type RouteDefinitions = { [key: string]: RouteDefinition };

let router: RemixRouter;
export const createBaseRouter = (routes: RouteObject[]): RemixRouter => (router = createBrowserRouter(routes));

export function getLinkTo(owner: RoutesName | string | number, options: { uuid: string } & any = {}): string {
  let push;
  switch (owner as RoutesName) {
    // PUBLIC
    case 'login':
      push = '/public/app/:app/login'.replace(':app', options.app) + '?' + qs.stringify(options.search);
      break;
    case 'registrar':
      push = '/public/app/:app/registrar'.replace(':app', options.app) + '?' + qs.stringify(options.search);
      break;
    case 'recuperarsenha':
      push = '/public/recuperarsenha/:codigo'.replace(':codigo', options.codigo || '') + '?' + qs.stringify(options.search);
      break;

    case 'logout':
      push = Endpoints.logoutRoute + '?' + qs.stringify(options.search);
      break;
    // ACCOUNT
    case 'conta':
      push = '/conta/inicio';
      break;
    //
    case 'dispositivos_conectados':
      push = '/dispositivos/conectados';
      break;
    case 'historico_logins':
      push = '/logins/historico';
      break;
    case 'planner':
      push = Endpoints.apiRedirect + '/planner';
      break;
    default:
      push = owner as string;
      break;
  }

  if (options?.inModal) {
    const search = window.location.search + qs.stringify(options.search);
    let newLocation = window.location.pathname + '/modal' + push + '?' + search;
    if (options?.showSave) {
      newLocation = newLocation + '&show_save=show_save';
    }
    return newLocation;
  }

  return push;
}

export function historyRemove(sufix: string) {
  const anterior = router.state.location.pathname.replace(new RegExp(`${sufix}.*`, 'g'), '') as string;

  historyPush(anterior);
}

export function historyPush(
  owner: RoutesName | string | number,
  options: { uuid?: any; inModal?: boolean; showSave?: boolean; open?: boolean; absolute?: boolean; search?: string } & any = {},
) {
  // Quando informado número, volta pra páginas anteriores ou posteriores.
  if (typeof owner === 'number') {
    window.history.back();
    //router.navigate(owner);
  }

  const push = getLinkTo(owner, options);

  if (options?.open) {
    if (options.absolute) {
      window.open(push);
    } else {
      window.open(`${push}`);
    }
  } else {
    if (options.absolute) {
      window.location.href = push;
      return;
    }
    router.navigate(push);
  }
}
